export default {
  items: [
    /* {
      lang_key: 'map',
      name: 'Map',
      url:  '/map',
      icon: 'icon-map',
    }, */
    {
      lang_key: 'orders',
      name: 'Orders',
      url:  '/order-management',
      icon: 'icon-bag',
    },
    {
      lang_key: 'goods',
      name: 'Goods',
      url:  '/goods-management',
      icon: 'icon-book-open',
    },
    /*
    {
      lang_key: 'dashboard',
      name: 'Dashboard',
      url:  '/dashboard',
      icon: 'icon-speedometer',
    },{
      lang_key: 'billing',
      name: 'Billings',
      //url:  '/company-billings',
      url:  '/company-charges',
      icon: 'icon-wallet',
    },
    {
      lang_key: 'categories',
      name: 'Categories',
      url:  '/categories-management',
      icon: 'icon-list'
    },   
    {
      lang_key: 'attributes',
      name: 'Features',
      url:  '/properties-management',
      icon: 'icon-tag',
    },
    {
      lang_key: 'providers',
      name: 'Drivers',
      url:  '/provider-management',
      icon: 'fa fa-motorcycle',
    },
    {
      lang_key: 'clients',
      name: 'Clients',
      url:  '/clients-management',
      icon: 'icon-people',
    },
    {
      lang_key: 'company',
      name: 'Settings',
      url:  '/settings',
      icon: 'icon-settings',
    },
    {
      lang_key: 'reports',
      name: 'Reports',
      url:  '/reports',
      icon: 'fa fa-print',
    },*/
  ],
};




// WEBPACK FOOTER //
// ./src/_nav_en.js